<section class="entire-section">
  <!-- <div class="header">
    <p class="heading">Colors</p>
    <mat-icon class="cursor-pointer" (click)="closeDialog()">close</mat-icon>
  </div>
 -->
  <div class="content-section">
    <div class="tabs">
      <div [ngClass]="{'selected-tab' : selectedTab === 'Theme', 'left-tab-border' : selectedTab === 'Theme'}"
        (click)="changeTabs('Theme')">From theme</div>
      <div [ngClass]="{'selected-tab' : selectedTab === 'Custom', 'right-tab-border' : selectedTab === 'Custom'}"
        (click)="changeTabs('Custom')">Custom</div>
    </div>

    <ng-container *ngIf="selectedTab === 'Theme'">
      <div *ngFor="let theme of themes" class="mt-20" (click)="selectTheme(theme.id)">
        <div class="color-pallet" [ngStyle]="{'background-color' : theme.color}"
          [ngClass]="{'selectedTheme': theme.selected}">
          <div class="accent-color">
            <div [ngStyle]="{'background-color' : theme.accentColor}"></div>
            <p>Dd</p>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'Custom'">
      <p class="heading mt-20">Background</p>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-select [(ngModel)]="backgroundData.backgroundType" (ngModelChange)="changeBackground()">
          <ng-container *ngFor="let type of backgroundType">
            <mat-option [value]="type">{{type | titlecase}}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <div class="mt-20">
        <div class="text-background">
          <input type="color" class="color" [(ngModel)]="backgroundData.color" (ngModelChange)="changeBackground()">
          <input type="text" class="color-code" [(ngModel)]="backgroundData.color" (ngModelChange)="changeBackground()">
        </div>
      </div>

      <div class="mt-20" *ngIf="backgroundData.backgroundType === 'Gradient'">
        <div class="text-background">
          <input type="color" class="color" [(ngModel)]="backgroundData.secondaryColor"
            (ngModelChange)="changeBackground()">
          <input type="text" class="color-code" [(ngModel)]="backgroundData.secondaryColor">
        </div>
      </div>

      <div class="link-type mt-20" *ngIf="backgroundData.backgroundType === 'Gradient'">
        <p>Direction</p>
        <div class="buttons ml-auto">
          <div class="left-tab" (click)="changeBackgroundType('DOWN')"
            [ngClass]="{'selected-tab' : backgroundData.backgroundGradientDirection === 'DOWN'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24"
              height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
          <div class="mid-tab" (click)="changeBackgroundType('RIGHT')"
            [ngClass]="{'selected-tab' : backgroundData.backgroundGradientDirection === 'RIGHT'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24"
              height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14 5 7 7m0 0-7 7m7-7H3">
              </path>
            </svg>
          </div>
          <div class="right-tab" (click)="changeBackgroundType('DIAGONAL_RIGHT')"
            [ngClass]="{'selected-tab' : backgroundData.backgroundGradientDirection === 'DIAGONAL_RIGHT'}">
            <svg style="transform: rotateZ(240deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"
              viewBox="0 0 24 24" width="24" height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
          <div class="right-tab" (click)="changeBackgroundType('DIAGONAL_LEFT')"
            [ngClass]="{'selected-tab' : backgroundData.backgroundGradientDirection === 'DIAGONAL_LEFT'}">
            <svg style="transform: rotateZ(135deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"
              viewBox="0 0 24 24" width="24" height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
        </div>
      </div>
      <hr class="line">
      <p class="heading mt-20">Accent</p>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-select [(ngModel)]="backgroundData.accentBackgroundType" (ngModelChange)="changeAccentColor()">
          <ng-container *ngFor="let type of backgroundType">
            <mat-option [value]="type">{{type | titlecase}}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <div class="mt-20">
        <div class="text-background">
          <input type="color" class="color" [(ngModel)]="backgroundData.accentColor"
            (ngModelChange)="changeAccentColor()">
          <input type="text" class="color-code" [(ngModel)]="backgroundData.accentColor">
        </div>
      </div>
      <div class="mt-20" *ngIf="backgroundData.accentBackgroundType === 'Gradient'">
        <div class="text-background">
          <input type="color" class="color" [(ngModel)]="backgroundData.secondaryAccentColor"
            (ngModelChange)="changeAccentColor()">
          <input type="text" class="color-code" [(ngModel)]="backgroundData.secondaryAccentColor">
        </div>
      </div>
      <div class="link-type mt-20" *ngIf="backgroundData.accentBackgroundType === 'Gradient'">
        <p>Direction</p>
        <div class="buttons ml-auto">
          <div class="left-tab" (click)="changeAccentGradientDirection('DOWN')"
            [ngClass]="{'selected-tab' : backgroundData.gradientDirection === 'DOWN'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24"
              height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
          <div class="mid-tab" (click)="changeAccentGradientDirection('RIGHT')"
            [ngClass]="{'selected-tab' : backgroundData.gradientDirection === 'RIGHT'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24"
              height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14 5 7 7m0 0-7 7m7-7H3">
              </path>
            </svg>
          </div>
          <div class="right-tab" (click)="changeAccentGradientDirection('DIAGONAL_RIGHT')"
            [ngClass]="{'selected-tab' : backgroundData.gradientDirection === 'DIAGONAL_RIGHT'}">
            <svg style="transform: rotateZ(240deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"
              viewBox="0 0 24 24" width="24" height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
          <div class="right-tab" (click)="changeAccentGradientDirection('DIAGONAL_LEFT')"
            [ngClass]="{'selected-tab' : backgroundData.gradientDirection === 'DIAGONAL_LEFT'}">
            <svg style="transform: rotateZ(135deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"
              viewBox="0 0 24 24" width="24" height="24" class="icon w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m19 14-7 7m0 0-7-7m7 7V3">
              </path>
            </svg>
          </div>
        </div>
      </div>

      <hr class="line">
      <div>
        <p class="heading">Preview</p>
        <div class="color-pallet"
          [style.background]="backgroundData.backgroundType === 'Solid' ? backgroundData.color : 'linear-gradient(' + getBackgroundDirection(backgroundData.backgroundGradientDirection) + ', ' + backgroundData.color + ', ' + backgroundData.secondaryColor + ')'">
          <div class="accent-color">
            <div *ngIf="backgroundData.accentBackgroundType === 'Solid'"
              [style.background]="backgroundData.accentColor"></div>
            <div *ngIf="backgroundData.accentBackgroundType === 'Gradient'" [ngStyle]="{
    'background': 'linear-gradient(' + getBackgroundDirection(backgroundData.gradientDirection) + ', ' + backgroundData.accentColor + ' 0%, ' + backgroundData.secondaryAccentColor + ' 100%)'
  }"></div>

            <p>Custom</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>